import convertStringToKebabCase from './convertStringToKebabCase';

const getTherapeuticTypePath = (type: string | undefined, id: string): string => {
  const [convertedType] = convertStringToKebabCase([type ?? '']);

  return convertedType ? `${convertedType}/${id}` : id;
};

export default getTherapeuticTypePath;
